export default "__VITE_ASSET__5HXnToHMUZ4e37mIHokeLA__"